import { AnimatePresence } from "framer-motion";
import { useTutorialStore } from "../../stores/tutorialStore";
import { TutorialArrow } from "./TutorialArrow";
import { TutorialCanvasHint } from "./TutorialCanvasHint";
import { TutorialStep } from "./TutorialStep";
import { TUTORIAL_STEPS } from "./TutorialStepContent";

export function TutorialOverlay() {
	const isActive = useTutorialStore((s) => s.isActive);
	const currentStep = useTutorialStore((s) => s.currentStep);

	const stepDef = TUTORIAL_STEPS[currentStep];
	if (!isActive || !stepDef) return null;

	return (
		<>
			{/* Blocking backdrop for welcome/completion cards */}
			<AnimatePresence>
				{stepDef.isBlocking && (
					<div className="tutorial-overlay tutorial-overlay--blocking" key="backdrop" />
				)}
			</AnimatePresence>

			{/* Canvas region hint */}
			<AnimatePresence>
				{stepDef.canvasRegion && (
					<TutorialCanvasHint key={`canvas-${stepDef.id}`} region={stepDef.canvasRegion} />
				)}
			</AnimatePresence>

			{/* Arrow pointing to DOM element */}
			{stepDef.targetSelector && !stepDef.canvasRegion && (
				<TutorialArrow targetSelector={stepDef.targetSelector} cardPosition={stepDef.position} />
			)}

			{/* Step card */}
			<AnimatePresence mode="wait">
				<TutorialStep key={stepDef.id} step={stepDef} />
			</AnimatePresence>
		</>
	);
}
